import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./store";
import reportWebVitals from "./reportWebVitals";
import { SessionAuthProvider, JWTAuthProvider } from "./providers/AuthProvider";
import { PrivateRoute } from "./components/PrivateRoute";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import MyCharacters from "./pages/MyCharacters";
import Preview from "./pages/Preview";
import Terms from "./pages/Terms";
import CharacterView from "./pages/CharacterView";
import Pricing from "./pages/Pricing";

import { USE_JWT } from "./Config";
import CharacterVariant from "./pages/CharacterVariant";

const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/terms-of-service",
        element: <Terms />,
      },
      {
        path: "/privacy-policy",
        element: <Terms />,
      },
      {
        path: "/pricing",
        element: <Pricing />,
      },
      {
        path: "/characters",
        element: (
          <PrivateRoute>
            <MyCharacters />
          </PrivateRoute>
        ),
      },
      {
        path: "/character/:id?",
        element: (
          <PrivateRoute>
            <CharacterView />
          </PrivateRoute>
        ),
      },
      {
        path: "/character/:id/variant/:index/",
        element: (
          <PrivateRoute>
            <CharacterVariant />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/preview",
    element: <Preview />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

if (USE_JWT) {
  root.render(
    <JWTAuthProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </JWTAuthProvider>
  );
} else {
  root.render(
    <SessionAuthProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </SessionAuthProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
